export const AppName = ({title}) => (
  <span className="font-inter-semibold text-[16px]">{title}</span>
);
